import ErrorView from './ErrorView'
import LoadingIndicator from './LoadingIndicator'

export default function NewStatusView<T>({
  data,
  isLoading,
  error,
  children,
}: {
  data: T | undefined
  isLoading: boolean
  error: Error | null
  children: (data: T) => React.ReactNode
}) {
  if (isLoading) return <LoadingIndicator />
  if (error) return <ErrorView error={error} />
  if (!data) return null
  return <>{children(data)}</>
}
